var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.startCall()}}},[_c('img',{attrs:{"src":"https://img.icons8.com/ios-glyphs/16/ffffff/phone-disconnected.png"}}),_vm._v(" Call ")])}
var staticRenderFns = []

export { render, staticRenderFns }